module.exports = __webpack_public_path__ + "static/media/scarecrow.d6ae55fa.svg";